import { ApolloQueryResult } from '@apollo/client';
import {
  GetDonorLivesSavedQuery,
  GetDonorLivesSavedQueryVariables,
} from 'gql/types';
import { GET_DONOR_LIVES_SAVED_QUERY } from 'modules/donor/graphql/queries';
import { apolloClient } from 'providers/graphql';

export const getDonorLSR = (
  donorId: string
): Promise<ApolloQueryResult<GetDonorLivesSavedQuery>> => {
  return apolloClient.query<
    GetDonorLivesSavedQuery,
    GetDonorLivesSavedQueryVariables
  >({
    query: GET_DONOR_LIVES_SAVED_QUERY,
    variables: {
      input: {
        donorId,
      },
    },
  });
};
